import { modelOptions, prop } from '@typegoose/typegoose';
import mongoose from 'mongoose';
import { ScoreBreakdown } from './riskManagement.common.model';

@modelOptions({
  schemaOptions: { collection: 'companyEndpointState' },
  options: { customName: 'companyEndpointState' },
})
export class CompanyEndpointStateModel {
  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true })
  endpointId: mongoose.Types.ObjectId;

  @prop({ required: true, type: ScoreBreakdown })
  scoreBreakdown: ScoreBreakdown;

  @prop()
  misconfigurationIds: number[];

  @prop()
  endpointName: string;

  @prop()
  endpointType: number;

  @prop()
  status: number;

  @prop()
  state: number;

  @prop()
  operatingSystem: number;
}
